// Local SEO data for /locations/:city/:service landing pages
// Do NOT modify without updating sitemap in /app/backend/seo_routes.py

export const cities = [
  {
    slug: 'abbotsford',
    name: 'Abbotsford',
    province: 'BC',
    geo: { latitude: '49.0504', longitude: '-122.3045' },
  },
  {
    slug: 'mission',
    name: 'Mission',
    province: 'BC',
    geo: { latitude: '49.1341', longitude: '-122.3097' },
  },
  {
    slug: 'langley',
    name: 'Langley',
    province: 'BC',
    geo: { latitude: '49.1044', longitude: '-122.6603' },
  },
  {
    slug: 'maple-ridge',
    name: 'Maple Ridge',
    province: 'BC',
    geo: { latitude: '49.2193', longitude: '-122.5989' },
  },
  {
    slug: 'chilliwack',
    name: 'Chilliwack',
    province: 'BC',
    geo: { latitude: '49.1579', longitude: '-121.9515' },
  },
];

export const services = [
  {
    slug: 'full-detail-package',
    name: 'Full Detail Package',
    heroTitle: 'Full Detail',
    tagline:
      'Full interior + exterior detailing with 6-12 month hand-applied ceramic wax coating.',
    description:
      'Most popular! Full interior + exterior detailing with 6-12 month hand-applied ceramic wax coating. Deep cleaning and long-lasting protection for that new-car look and feel.',
    workspace: 'driveway',
    workspaceNote:
      'Driveway service available at your home or workplace. No garage required.',
  },
  {
    slug: 'interior-only',
    name: 'Interior Only Deep Detail',
    heroTitle: 'Interior Detail',
    tagline:
      'Full cabin reset with thermal steam disinfection and deep extraction.',
    description:
      'Full cabin reset. Thermal steam disinfection, deep carpet & upholstery extraction, leather conditioning, and stain removal. Eliminates pet hair, spills, and odors for that true brand-new feel.',
    workspace: 'driveway',
    workspaceNote:
      'Driveway service available at your home or workplace. No garage required.',
  },
  {
    slug: 'exterior-only',
    name: 'Exterior Only Wash & Ceramic Wax',
    heroTitle: 'Exterior Detail',
    tagline:
      'Complete exterior wash, decontamination, and 6-12 month hand-applied ceramic wax.',
    description:
      'Complete exterior wash, decontamination, and 6-12 month hand-applied ceramic wax coating for showroom shine and lasting protection. Wheels and wheel wells receive a deep cleaning.',
    workspace: 'driveway',
    workspaceNote:
      'Driveway service available at your home or workplace. No garage required.',
  },
  {
    slug: '8-year-signature-ceramic-coating',
    name: '8-Year Signature Ceramic Coating',
    heroTitle: 'Ceramic Coating',
    tagline:
      'Crystal Brite Semi-Permanent Coating + Single Stage Machine Polish.',
    description:
      'Crystal Brite Semi-Permanent Coating + single stage polish. 6-8 years premium protection with 9H hardness, high-definition shine, and self-cleaning properties. Garage or covered workspace required.',
    workspace: 'garage',
    workspaceNote:
      'Garage or covered workspace required for proper curing of the ceramic coating.',
  },
  {
    slug: 'permanent-headlight-restoration',
    name: 'Permanent Headlight Restoration',
    heroTitle: 'Headlight Restoration',
    tagline:
      'Wet sanding, polishing, and UV-protective 9H ceramic coating.',
    description:
      'Restore cloudy, yellowed headlights to crystal-clear factory-new condition with wet sanding, polishing, and UV-protective 9H ceramic coating. Improves safety and appearance. Available as a $49 add-on with any Exterior Wash, Full Detail, or Ceramic Coating package.',
    workspace: 'driveway',
    workspaceNote:
      'Driveway service available at your home or workplace. No garage required.',
  },
];

// Generate all 25 combinations for sitemap / footer link generation
export const allLocationServicePaths = cities.flatMap((c) =>
  services.map((s) => ({
    path: `/locations/${c.slug}/${s.slug}`,
    city: c,
    service: s,
  }))
);
